module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "pt1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PT"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_1",
      "title": "1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("How Do I Live a Full Life?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "PEP1"
  }, [_vm._v("Pay attention.")]), _vm._v(" "), _c('p', {
    staticClass: "PEP1"
  }, [_vm._v("Be astonished.")]), _vm._v(" "), _c('p', {
    staticClass: "PEP"
  }, [_vm._v("Tell about it.")]), _vm._v(" "), _c('p', {
    staticClass: "PEPC"
  }, [_c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ARY")]), _vm._v(" O"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("LIVER")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02826ec8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 72
// module chunks = 0